import IShipment from 'src/types/IShipment';
import IStoreState from 'src/types/IStoreState';

export function getShipment(state: IStoreState): IShipment | undefined {
  return state.shipment.shipment;
}
